import { createStore, applyMiddleware, compose } from 'redux';
import reactImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

export default function configureStore() {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const middlewares = [thunk];
  if (process.env.NODE_ENV === 'development') {
    middlewares.push(reactImmutableStateInvariant());
  }
  return createStore(rootReducer, composeEnhancers(applyMiddleware(...middlewares)));
}
